// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"cd6675f8","453":"258b012d","627":"5db52ebf","738":"5418cbf1","923":"6110a3a3"}[chunkId] + ".chunk.js";
};